/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Links_1_LabelInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_links_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Links_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to the homepage comparison`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_links_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Links_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页对比区`)
};

/**
* | output |
* | --- |
* | "Return to the homepage comparison" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Links_1_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_links_1_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Links_1_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Links_1_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_links_1_label(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_links_1_label(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_links_1_label as "gc.search_guides.gridcraft_vs_excel.sections.7.links.1.label" }